import Axios from "../../src/helpers/axios";

export const fetchAutoComplete = (query) => {
  return Axios.get(`/api/ecommerce/v1/location/search/${query}`);
};

export const fetchPlaceDetails = (placeId) => {
  return Axios.get(`/api/ecommerce/v1/location/details/${placeId}`)
}